import { gql } from "@apollo/client";

export const getStoreGroupsSummary = gql`
  mutation GetStoreGroupsSummary($limit: Int, $offset: Int) {
    getStoreGroupsSummary(
      input: { sortBy: "name" }
      limit: $limit
      offset: $offset
    ) {
      total
      items {
        name
        amountOfStores
        zipCodes
      }
    }
  }
`;
